import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../App.css";
import { loginService } from "../services/authService";
import Alert from "../components/Alert";

const INDOMIE_LOGO = "https://sawake.kraitech.co.ke/images/logo.png";

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    setError("");

    if (!email || !password) {
      setError("Email and password are required.");
      return;
    }

    setLoading(true);
    try {
      const response = await loginService(email, password);
      console.log("Login success:", response);
      navigate("/dashboard");
    } catch (err) {
      setError(err.message || "Invalid credentials. Please try again.");
      await new Promise(resolve => setTimeout(resolve, 100));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page">
      {error && (
        <Alert 
          type="error" 
          message={error} 
          onClose={() => setError("")}
        />
      )}
      <div className="card">
        <div className="logo-wrap">
          <img
            src={INDOMIE_LOGO}
            alt="Indomie"
            className="logo"
            onError={(e) => {
              e.target.style.display = "none";
              e.target.nextSibling.style.display = "flex";
            }}
          />
          <div className="fallback-logo" style={{ display: "none" }}>
            <span className="fallback-text">Indomie</span>
          </div>
        </div>

        <h1 className="title">Admin Login</h1>
        <p className="subtitle">Sign in to access the admin dashboard</p>

        <form onSubmit={handleSubmit} noValidate className="form">
          <div className="field-group">
            <label className="label">Email Address</label>
            <div className="input-wrap">
              <span className="icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2">
                  <rect x="2" y="4" width="20" height="16" rx="2"/>
                  <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
                </svg>
              </span>
              <input
                type="email"
                value={email}
                onChange={(e) => { setEmail(e.target.value); setError(""); }}
                className="input"
                placeholder="Enter your email"
              />
            </div>
          </div>

          <div className="field-group">
            <label className="label">Password</label>
            <div className="input-wrap">
              <span className="icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                </svg>
              </span>
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => { setPassword(e.target.value); setError(""); }}
                className="input"
                placeholder="Enter your password"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="eye-btn"
              >
                {showPassword ? (
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                    <line x1="1" y1="1" x2="23" y2="23"/>
                  </svg>
                ) : (
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                )}
              </button>
            </div>
          </div>

          <div className="row">
            <label className="check-label">
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
                className="checkbox"
              />
              Remember me
            </label>
            <button type="button" className="forgot-btn">Forgot password?</button>
          </div>

          <button
            type="submit"
            className={`sign-in-btn ${loading ? "loading" : ""}`}
            disabled={loading}
          >
            {loading ? <span className="spinner"></span> : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}